// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","basket":"basket_JK7LL","basketPrice":"basketPrice_DUvBg"};